import * as React from "react";

function SvgNoImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 251 336"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.652 11.0569L198.712 0.75L174.572 42.3579H22.9095C11.3632 42.3579 0.102692 53.5635 0.102692 65.0532V269.31C0.102692 280.8 11.3632 292.006 22.9095 292.006H29.7289L10.5558 325.052L28.3064 335.25L216.652 11.0569ZM128.484 121.793H56.1697C50.3966 121.793 45.7166 126.45 45.7166 132.195V202.172C45.7166 207.917 50.3966 212.574 56.1697 212.574H75.8142L128.484 121.793Z"
        fill="#E0E0E0"
      />
      <path
        d="M216.817 42.3579L168.629 125.415C170.203 127.236 171.154 129.605 171.154 132.195V156.028L200.477 133.721C202.649 132.068 205.364 134.134 205.364 137.439V196.925C205.364 200.23 202.649 202.296 200.477 200.643L171.154 178.336V202.172C171.154 207.917 166.474 212.574 160.701 212.574H118.06L71.9746 292.006H228.171C239.717 292.006 250.978 280.8 250.978 269.31V65.0532C250.978 53.5635 239.717 42.3579 228.171 42.3579L216.817 42.3579Z"
        fill="#E0E0E0"
      />
    </svg>
  );
}

export default SvgNoImage;
